import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Connectivity = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Connectivity' {...props}>
    <path fill='none' stroke='#000' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M6,8 L6,12 L9,15 L15,9 L11,5 L5,5 L2.5,3 M17,7 L20,10 L20,17 M13,11 L16,14 M11,13 L14,16 M7,17 L10,20 L20,20' />
  </StyledIcon>
);
